// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getProductById, getVariantChild } from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    SetProductInfo,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";
import { TurnerProductInfo } from "@turnerBlueprint/App/Services/TurnerApiModels";

addToChainAfter(chain, SetProductInfo, TurnerPopulateExtendedProductInfo);

async function TurnerPopulateExtendedProductInfo(props: any) {
    if (props.variantSelectionCompleted) {
        if (props.productInfo.productId === props.parameter.productId) {
            return;
        }
        const productChild = await getVariantChild({
            id: props.productInfo.productId,
            variantParentId: props.parameter.productId,
            expand: ["detail", "specifications", "content", "images", "documents", "attributes"],
        });
        props.productInfo = {
            ...props.productInfo,
            upcCode: productChild.detail?.upcCode,
            productLine: productChild.productLine,
            documents: productChild.documents,
            images: productChild.images,
            specifications: productChild.specifications,
            content: productChild.content,
            manufacturerItem: productChild.manufacturerItem,
            brand: productChild.brand,
        };
    }
}
